export const JOURNAL = 'journal' as const
export const JSTOR = 'jstor' as const
